<template>
	<div class="relative">
		<div>
			<GoogleBrowser
				:types="['(regions)']"
				:is-x-s="isXS"
				:placeholder="placeholder"
				small
				@select="selectPlace"
				@click-result="isLoading = true"
			/>
			<div
				class="width-full pt-2 overflow-auto"
				:style="{
					minHeight: `140px`,
					maxHeight: `140px`,
				}"
			>
				<div class="d-flex flex-wrap gap-2 justify-start height-full width-full">
					<Chip
						v-for="destination in travelList"
						:key="destination.id!"
						:class="`text-${colorPalette}-700 bg-${colorPalette}-25`"
					>
						<div class="d-flex gap-2 align-center">
							<span> {{ destination.name }}</span>
							<button
								class="d-flex align-center bg-neutral-25 rounded-circle"
								@click="() => removePlace(destination.id!)"
							>
								<Icon icon="close" :class="`text-${colorPalette}-700`" radius="20px" />
							</button>
						</div>
					</Chip>

					<div v-if="isLoading" class="chip-skeleton">
						<Skeleton :class="isXS ? 'chip--skeleton-s' : 'chip-skeleton-m'" class="rounded-pill" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Destination2 } from '~/models/Destination'
	import { Spot2 } from '~/models/Spot'
	import EventsService from '~/services/events'
	import { useI18n } from 'vue-i18n'
	import { ref } from 'vue'

	const { t } = useI18n()

	interface Props {
		isXS: boolean
		placeholder?: string
		colorPalette?: 'primary' | 'secondary'
		travelList: Record<string, Destination2 | Spot2>
	}
	const isLoading = ref<boolean>(false)

	const props = withDefaults(defineProps<Props>(), {
		placeholder: '',
		colorPalette: 'primary',
	})

	const emit = defineEmits(['updateDestinations', 'updateDestinations'])

	const selectPlace = (place: Destination2 | Spot2) => {
		if (!place?.id) {
			return EventsService.emitError(t('error_destination_not_found'))
		}
		const selectedPlaces: Record<string, Destination2 | Spot2> = {
			...props.travelList,
			[place.id]: place,
		}
		emit('updateDestinations', selectedPlaces)
		isLoading.value = false
	}

	const removePlace = (placeId: string) => {
		const selectedPlaces = { ...props.travelList }
		delete selectedPlaces[placeId]
		emit('updateDestinations', selectedPlaces)
	}
</script>
<style lang="scss" scoped>
	.chip-skeleton-m {
		width: 120px;
		height: 40px;
	}
	.chip--skeleton-s {
		width: 120px;
		height: 32px;
	}
</style>
